var minimodal = require('minimodal');

var targets = document.querySelectorAll('[data-minimodal]');

for (var i = 0; i < targets.length; i += 1) {
  var rootClass = targets[i].getAttribute('data-minimodal-rootClass') || '';
  var modal = minimodal(targets[i], {
    rootClass: rootClass,
    statusTimeout: 600,
    removeTimeout: 600,
    closeTimeout: 600,
  });
  modal.init();
}
